export const DEFAULT_EMPTY_MESSAGE_TEST_ID = 'empty-message'
export const EMPTY_RESULTS_MESSAGE = 'Hmm, no citation lists matched that search'
